import { ref } from 'vue';
// import {
//     authState,
//     // waitUntilReady
// } from "@/ui-plus/useAuth";
import type { NotificationPermissionSnapshot } from '@lib/deliveryteamCourierWebviewBridge/contract';
// import { callNative } from '@deliveryteam-spa-orders-vue/native';
import { registerWebHandler } from '@lib/deliveryteamCourierWebviewBridge';
// import { deliveryteamOrdersApiClient } from '@api-client/deliveryteam_orders';
import { loadOrders } from '@deliveryteam-spa-orders-vue/refs/RecentOrders';


// waitUntilReady.then(() => {
//     if (authState.value?.accessTokenPayload !== null) {
//         checkNotificationPermission();
//     }
// });
// const startWatchingPushTokens = () => {
//     watch([authState, pushNotificationTokensRef], () => {
//         void sendPushTokensToBackend();
//     }, { immediate: false });
// }
// setTimeout(() => {
//     startWatchingPushTokens();
// }, 3000);

// const pushNotificationTokensRef = ref<{
//     devicePushToken: {
//         type: string;
//         data: string;
//     };
// } | undefined>();

// function resolveDeviceType(
//     devicePushToken: { type: string },
// ): 'ios' | 'android' | undefined {
//     if (devicePushToken.type === 'ios' || devicePushToken.type === 'android') {
//         return devicePushToken.type;
//     }
//     return undefined;
// }

// async function sendPushTokensToBackend() {
//     const tokens = pushNotificationTokensRef.value;
//     if (!tokens || !authState.value?.accessTokenPayload?.id) {
//         return;
//     }

//     const deviceType = resolveDeviceType(tokens.devicePushToken);
//     if (!deviceType) {
//         return;
//     }

//     try {
//         const response = await (await deliveryteamOrdersApiClient.courier_save_push_token.$post({
//             json: {
//                 devicePushToken: tokens.devicePushToken.data,
//                 deviceType,
//             },
//         })).json();

//         if (response.error) {
//             console.error('Failed to save courier push tokens', response.error);
//         }
//     } catch (error) {
//         console.error('Failed to save courier push tokens', error);
//     }
// }

const notificationHandler = async () => {
    console.log('notificationHandler ❌❌❌ not implemented');
    // const devicePushToken = await callNative('getDevicePushTokenAsync', undefined);
    // pushNotificationTokensRef.value = {
    //     devicePushToken: devicePushToken,
    // };
    // await sendPushTokensToBackend();
    // await callNative('startNotificationReceivedListener', undefined);
};

registerWebHandler('pushTokenChanged', function () {
    console.log('pushTokenChanged🟪🟪🟪');
    notificationHandler();
});

registerWebHandler('notificationReceived', ({ data }) => {
    const deliveryteamId = data?.deliveryteamId;
    const deliveryteamOrderId = data?.deliveryteamOrderId;
    if (deliveryteamId !== null && deliveryteamOrderId !== null) {
        void loadOrders(String(deliveryteamId), [String(deliveryteamOrderId)]);
    }
});

const notificationPermissionRef = ref<NotificationPermissionSnapshot | null>(null);

const requestNotificationPermission = async () => {
    console.log('requestNotificationPermission ❌❌❌ not implemented');
    // const permission = await callNative('requestNotificationPermission', undefined);
    // if (permission.granted) {
    //     notificationHandler();
    // }
    // notificationPermissionRef.value = permission;
};

const checkNotificationPermission = async () => {
    console.log('checkNotificationPermission ❌❌❌ not implemented');
    // const permission = await callNative('checkNotificationPermission', undefined);
    // if (permission.granted) {
    //     notificationHandler();
    // }
    // notificationPermissionRef.value = permission;
};

export {
    requestNotificationPermission,
    checkNotificationPermission,
    notificationPermissionRef
};
